var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"logo","src":require("../assets/images/logo.png")}}),_c('div',{staticClass:"main"},[_c('left'),_c('middle'),_c('right')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }